import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { MainApi } from '_api';
import { handleError, handleResponse } from '_helpers/api';

export const getCredentials = createAsyncThunk(
  'credentials/getCredentials',
  async function ({ customerId }, { rejectWithValue }) {
    try {
      const response = await MainApi.getCredentials({ customerId });
      return handleResponse(response);
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

export const setCredentials = createAsyncThunk(
  'credentials/setCredentials',
  async function ({ customerId, brandCategory, username, password, oldPassword }, { rejectWithValue }) {
    try {
      await MainApi.setCredentials({
        customerId,
        body: {
          brandCategory,
          username,
          password,
          oldPassword,
        },
      });
      toast.success('Credentials were changed successfully!');
    } catch (error) {
      const parsedError = handleError(error);
      toast.error(parsedError?.message || 'Something went wrong');
      return rejectWithValue(parsedError);
    }
  }
);

const credentialsSlice = createSlice({
  name: 'credentials',
  initialState: {
    data: [],
    error: null,
    loading: false,
    updating: false,
  },
  reducers: {
    resetData(state) {
      state.data = [];
    },
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCredentials.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getCredentials.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getCredentials.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });

    builder
      .addCase(setCredentials.pending, (state) => {
        state.updating = true;
      })
      .addCase(setCredentials.fulfilled, (state) => {
        state.updating = false;
      })
      .addCase(setCredentials.rejected, (state) => {
        state.updating = false;
      });
  },
});

export const { resetData, resetError } = credentialsSlice.actions;

export default credentialsSlice.reducer;
